"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAfterDay = isAfterDay;
exports.isBeforeDay = isBeforeDay;
exports.isBeforeToday = isBeforeToday;
exports.isDateSelected = void 0;
exports.isDayOutsideRange = isDayOutsideRange;
exports.isInclusivelyAfterDay = isInclusivelyAfterDay;
exports.isSameDay = isSameDay;
exports.parseDate = parseDate;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_UTC_OFFSET = 9; // Japan Standard Timezone

function isBeforeDay(before, date) {
  if (!_moment["default"].isMoment(before) || !_moment["default"].isMoment(date)) return false;
  var beforeYear = before.year();
  var beforeMonth = before.month();
  var dateYear = date.year();
  var dateMonth = date.month();
  var isSameYear = beforeYear === dateYear;
  var isSameMonth = beforeMonth === dateMonth;
  if (isSameYear && isSameMonth) return before.date() < date.date();
  if (isSameYear) return beforeMonth < dateMonth;
  return beforeYear < dateYear;
}

function isSameDay(dateA, dateB) {
  if (!_moment["default"].isMoment(dateA) || !_moment["default"].isMoment(dateB)) return false;
  return dateA.date() === dateB.date() && dateA.month() === dateB.month() && dateA.year() === dateB.year();
}

function isAfterDay(after, date) {
  if (!_moment["default"].isMoment(after) || !_moment["default"].isMoment(date)) return false;
  return !isBeforeDay(after, date) && !isSameDay(after, date);
}

function parseDate(dateObj, options) {
  // Return empty string if input date is invalid
  if (!_moment["default"].isMoment(dateObj) || !(0, _moment["default"])(dateObj).isValid()) {
    return '';
  }

  var utcOffset = options && options.utcOffset || DEFAULT_UTC_OFFSET;

  if (options && options.startOfDay) {
    return (0, _moment["default"])(dateObj).startOf('day').utcOffset(utcOffset).format();
  }

  if (options && options.endOfDay) {
    return (0, _moment["default"])(dateObj).endOf('day').utcOffset(utcOffset).format();
  } // no time is specified


  return (0, _moment["default"])(dateObj).utcOffset(utcOffset).format();
}

function isDayOutsideRange(day, disable) {
  var outsideRange = false;

  if (disable && disable.before) {
    outsideRange = isBeforeDay(day, disable.before);
  }

  if (!outsideRange && disable && disable.after) {
    outsideRange = isAfterDay(day, disable.after);
  }

  return outsideRange;
}

function isBeforeToday(date) {
  var todaysDate = new Date();
  todaysDate.setHours(0, 0, 0, 0);
  return date.getTime() < todaysDate.getTime();
}

function isInclusivelyAfterDay(calendarDay) {
  return !isBeforeToday(calendarDay.toDate());
}

var isDateSelected = function isDateSelected(dates, momentDate) {
  if (!Array.isArray(dates) || !_moment["default"].isMoment(momentDate)) {
    return false;
  }

  return dates.some(function (date) {
    return date === momentDate.format('YYYY-MM-DD');
  });
};

exports.isDateSelected = isDateSelected;